import { toast } from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TView } from '@shared/types/view';

export const setViewAsDefault = async (view: string | number) => {
  const res = await request<TView>({
    url: `views/${view}/set-default/`,
    method: 'PATCH',
  });

  return res;
};

export const useSetViewAsDefault = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setViewAsDefault,

    onSuccess: () => {
      toast.success('Saved');
    },

    onSettled: () => {
      queryClient.invalidateQueries({
        predicate(q) {
          return (
            Array.isArray(q.queryKey) &&
            (q.queryKey[0] === QUERY_KEYS.getViews ||
              q.queryKey[0] === QUERY_KEYS.getInfiniteViews)
          );
        },
      });
    },
  });
};
